import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { CapitalizeFirstLetterPipe, LiveActionBarComponent } from '@ftr/foundation'
import { FilterComponent } from '../list'
import { LiveTableLayoutComponentFilterDefinition } from './live-table-layout.component'

@Component({
  standalone: true,
  selector: 'ftr-live-table-layout-header',
  templateUrl: './live-table-layout-header.component.html',
  styleUrls: ['./live-table-layout-header.component.css'],
  imports: [CapitalizeFirstLetterPipe, FilterComponent, LiveActionBarComponent],
})
export class LiveTableLayoutHeaderComponent<FilterType extends string> implements OnInit {
  /**
   * The page title
   */
  @Input()
  title: string

  /**
   * How to refer to more than one item in the list
   */
  @Input()
  plural: string

  /**
   * How to refer to a single item in the list
   */
  @Input()
  singular: string

  /**
   * A summary of what this list is of
   */
  @Input()
  summary: string

  /**
   * A count of the items in the list
   */
  @Input()
  count: number

  /**
   * How often to automatically refresh the list items
   */
  @Input()
  updateIntervalMs: number

  /**
   * Notifies the parent that it should refresh its animated remote.
   */
  @Output()
  refresh: EventEmitter<void> = new EventEmitter<void>()

  /**
   * Was the last emission a success
   */
  @Input()
  isSuccess: boolean

  /**
   * Whether scrolling the page should pause automatic updates.
   * Useful when you have a large list and dont want the user to lose their place
   */
  @Input()
  pauseUpdatesOnScroll = false

  /**
   * The definition of the filter drop down to display
   */
  @Input() filter?: LiveTableLayoutComponentFilterDefinition<FilterType> | undefined

  ngOnInit(): void {
    this.filter = this.filter
      ? {
          ...this.filter,
          filterKey: this.filter.filterKey || this.title.replace(/[^a-zA-Z]/, '-').toLowerCase(),
          pageIdentifier: this.filter.pageIdentifier || this.title.replace(/[^a-zA-Z]/, '-').toLowerCase(),
        }
      : this.filter
  }
}
